// extracted by mini-css-extract-plugin
export default {"module":"textModalBody_module__5yQ8k","close":"textModalBody_close__IYaKZ","title":"textModalBody_title__vSX37","content":"textModalBody_content__+VH4G"};